<div ref:cover class="cover cover__{{$isMobile.any ? 'mobile' : 'desktop'}} cover__{{$cover_active ? 'visible' : 'hidden'}}">

    <div class="cover__group">
        <div class="cover__logo-group">
            <div class="cover__logo cover__logo--fl">
                FRONTLINE
            </div>
            <div class="cover__logo cover__logo--gt">
                The Ground Truth Project
            </div>
        </div>

        <div class="cover__sound">
            This experience has sound
        </div>

        {{#if $isMobile.any || ($bowser)}}
        <button class="cover__tap" on:click="removeCover()">Begin</button>
        {{/if}}
    </div>
</div>

<Slide :i :slide>
    <div class="title__inner"></div>

    <div class="slide__text">
        <div class="slide__text-outer scroll-text-outer">
            <p class="slide__text-inner scroll-text">
                {{#if !$isMobile.any}}
                <span class="scroll-icon">Scroll</span> or use your 
                <span class="keyboard-icon">keyboard</span> to begin
                {{/if}}
            </p>
        </div>
    </div>

    <div class="title">
        <p class="title__question">
            <span class="title__q-group title__q-group--1">
                <span class="q-word q-1">What</span> <span class="q-word q-2">is</span> <span class="q-word q-3">it</span> <span class="q-word q-4">like</span> <span class="q-word q-5">to</span> <span class="q-word q-6">grow</span> <span class="q-word q-7">up</span>
            </span>
            <span class="title__q-group title__q-group--2">
                <span class="q-word q-8">in</span> <span class="q-word q-9">a</span> <span class="q-word q-10">place</span> <span class="q-word q-11">that's</span> <span class="q-word q-12">going</span> <span class="q-word q-13">away?</span>
            </span>
        </p>
        <h1 class="title__main">The Last Generation</h1>
    </div>

    <div class="media-outer">
        {{#if $isMobile.any}}
        <img src="{{ poster(slide.poster) }}" alt="" />
        {{else}}
        <video ref:video preload="auto" muted playsinline loop="{{ slide.loop }}">
            {{#if slide.webm && ($bowser && $bowser.safari) }}<source src="{{ video(slide.webm) }}" type="video/webm">{{/if}}
            {{#if slide.mp4 }}<source src="{{ video(slide.mp4) }}" type="video/mp4">{{/if}}
        </video>
        {{/if}}
    </div>

    {{#if $bowser && ( $bowser.msie || $bowser.msedge ) && displayBrowserMessage}}
    <div class="browser-message">
        <p>This experience has not been not optimized for this browser.</p>
        <p>We recommend using the latest version of either Chrome or Safari.</p>
        <button on:click="removeBrowserMessage()">Close</button>
    </div>
    {{/if}}
</Slide>

<script>
import Slide from './Slide.html'
import { video, poster } from './helpers'
import { fadeIn } from './music'

import { timeout } from 'd3-timer'

export default {

    components: {
        Slide,
    },

    oncreate () {

        this.set({ displayBrowserMessage: true });

        const {video} = this.refs;

        this.observers = [];

        this.observers.push(this.store.observe('current_slide', (current, prev) => {
            if (current === this.get('i')) {
                this.play();
            } else {
                this.pause();
            }
        }));

        this.observers.push(this.store.observe('current_chapter', (current, prev) => {
            if ( this.store.get('current_slide') == this.get('i') ) {
                this.play();
            } else {
                this.pause();
            }
        }));

        this.observers.push(this.store.observe('index_active', current => {
            if (current) {
                this.pause();
            }  else if ( ( this.store.get('current_slide') == this.get('i') ) && ( this.store.get('current_chapter') == this.get('chapter') ) ) {
                //console.log( `play ${this.get('chapter')} /video ${this.get('i')}` );
                this.play();
            }
        }));

    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel();
        }
    },

    data() {
        return {
            i: 0,
            slide: {},
            displayBrowserMessage: true,
        }
    },

    methods: {
        play() {
            if (this.store.get('cover_active')) return false;
            const { video } = this.refs;
            video && video.play().catch(noop);
        },

        pause() {
            const { video } = this.refs;
            video && video.pause();
        },

        removeCover() {
            this.store.set({ cover_active: false }); 
            this.play();
            if( this.store.get('music')[this.get('slide').music] ) fadeIn(this.get('slide').music);
        },

        removeBrowserMessage() {
            this.set({ displayBrowserMessage: false });
        }
    },

    helpers: {
        video,
        poster,
    }
}
</script>
